// extracted by mini-css-extract-plugin
var _1 = "ku3BR";
export { _1 as "base" }
